exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".style-cssmodule-statusContainer-2Tx7G{display:flex;align-items:baseline}.style-cssmodule-actionsContainer-2YrUv{display:flex;justify-content:center;width:54px;margin:auto}.style-cssmodule-actions-3kB0m svg{stroke-width:1px;color:var(--color-night-gray6)}.style-cssmodule-actions-3kB0m button{all:unset;box-sizing:border-box;cursor:pointer;display:grid;place-items:center;padding:5px}.style-cssmodule-tooltipWithCopy-26Rap{display:flex;flex-direction:column;align-items:center}.style-cssmodule-tooltipWithCopy-26Rap:last-child{font-size:1px!important}.style-cssmodule-usernameContainer-3GN1X{max-width:120px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.style-cssmodule-carparksLinkedContainer-3dUxG{max-width:170px;display:flex}.style-cssmodule-emailContainer-hHy3J,.style-cssmodule-firstCarparkName-TerIL{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.style-cssmodule-emailContainer-hHy3J{max-width:175px}", ""]);

// exports
exports.locals = {
	"statusContainer": "style-cssmodule-statusContainer-2Tx7G",
	"actionsContainer": "style-cssmodule-actionsContainer-2YrUv",
	"actions": "style-cssmodule-actions-3kB0m",
	"tooltipWithCopy": "style-cssmodule-tooltipWithCopy-26Rap",
	"usernameContainer": "style-cssmodule-usernameContainer-3GN1X",
	"carparksLinkedContainer": "style-cssmodule-carparksLinkedContainer-3dUxG",
	"firstCarparkName": "style-cssmodule-firstCarparkName-TerIL",
	"emailContainer": "style-cssmodule-emailContainer-hHy3J"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]-[local]-[hash:base64:5]"}!./routes/cpm/routes/accounts/components/AccountRow/style.cssmodule.css
// module id = 2546
// module chunks = 121